import { request } from "../@utils";
import { requestFile } from "../@utils";
const ActivityService = {
    //获取团购活动列表
    getActivityGroupList: async (params) => {
        const res = await request.post("/activity/group/search",{ data: params });
        return res;
    },
    //新增团购活动
    createActivityGroup: async (params) => {
        const res = await request.post("/activity/group/create",{ data: params });
        return res;
    },
    //驳回团购活动
    rejectActivityGroup: async (code) => {
        const res = await request.post(`/activity/group/reject/${code}`);
        return res;
    },
    //获取团购活动详情
    getGroupDetail: async (code) => {
        const res = await request.get(`/activity/group/detail/${code}`);
        return res;
    },
    //提前结束团购活动
    finishActivityGroup: async (code) => {
        const res = await request.post(`/activity/group/finish/${code}`);
        return res;
    },
    //审核团购活动
    auditActivityGroup: async (code) => {
        const res = await request.post(`/activity/group/audit/${code}`);
        return res;
    },
    //删除团购活动
    deleteGroup: async (code) => {
        const res = await request.delete(`/activity/group/delete/${code}`);
        return res;
    },
    //获取团购活动备货清单
    getGoodsDetail: async (code) => {
        const res = await request.get(`/activity/group/goods-inventory/${code}`);
        return res;
    },
    exportStoreProduct: async (params) => {
        const res = await requestFile.post("/product/store-product/export",{ data: params,responseType: "blob" });
        return res;
    },
};
export default ActivityService;
